var app = angular.module("leonardo");

var AdminAccountFiltersController = function(
  $scope,
  $state,
  $controller,
  AccountService,
  ClientInstanceService,
  AccountRequestService,
  SectorRestService
) {

  $controller('FiltersBaseController', { $scope: $scope });

  const clientInstanceOptions = ClientInstanceService.getlist({ essential: true }).then(function (response) {
    return response.map(function (clientInstance) {
      return {
        id: clientInstance.id,
        name: `${clientInstance.name} (id: ${clientInstance.id})`
      };
    });
  });

  $scope.filters_options = [
    { group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'client_instances',
          name: 'Client Instance',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Client Instances',
          condition: $scope.authDataService.isAdmin(),
          options: clientInstanceOptions,
          conflicts: ['account_reports', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        }
      ]
    },
    {
      id: 'status',
      name: 'Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Status',
      condition: true,
      options: $state.current.request ? AccountRequestService.STATUS_OPTIONS : AccountService.STATUS_OPTIONS,
      conflicts: []
    },
    {
      id: 'sector',
      name: 'Sector',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'Select sector',
      condition: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
      service: SectorRestService,
      conflicts: ['category']
    },
    {
      id: 'search',
      name: 'Account Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Account name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];
};

app.controller('AdminAccountFiltersController', [
  '$scope',
  '$state',
  '$controller',
  'AccountService',
  'ClientInstanceService',
  'AccountRequestService',
  'SectorRestService',
  AdminAccountFiltersController
]);
